import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

/**
 * BackButton component for consistent navigation
 * Use on detail pages, nested routes, or anywhere users need to go back
 */
const BackButton = ({ 
  to = null, // Specific path to navigate to, or null for browser back
  label = 'Back',
  className = ''
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  };

  return (
    <Button 
      variant="ghost" 
      size="sm" 
      onClick={handleClick}
      className={`text-forest hover:text-terracotta hover:bg-transparent -ml-2 mb-4 ${className}`}
    >
      <ArrowLeft className="h-4 w-4 mr-1" />
      {label}
    </Button>
  );
};

export default BackButton;
